"use client";

export const WhatsAppFloat = ({ whatssAppConfig = {} }) => {
  const {
    enabled = true,
    phoneNumber = "+918097155300",
    message = "Hello! I'm interested in your services.",
    position = "bottom-right",
    tooltip = "Chat With Us",
  } = whatssAppConfig || {};

  if (!enabled) return null;

  const href = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(
    message,
  )}`;

  const style = {
    position: "fixed",
    zIndex: 1000,
    bottom: 20,
    right: position === "bottom-right" ? 20 : undefined,
    left: position === "bottom-left" ? 20 : undefined,
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
      aria-label={tooltip}
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="28" cy="28" r="28" fill="#25D366"></circle>

        <path
          d="M39.1 16.9C36.2 14 32.4 12.4 28.4 12.4C20.1 12.4 13.4 19.1 13.4 27.4C13.4 30 14.1 32.5 15.3 34.7L13.2 42.4L21.1 40.3C23.3 41.5 25.8 42.1 28.4 42.1C36.7 42.1 43.4 35.4 43.4 27.1C43.4 23.1 41.9 19.3 39.1 16.9ZM28.4 39.6C26 39.6 23.7 39 21.7 37.9L21.2 37.6L16.5 38.9L17.8 34.3L17.5 33.8C16.3 31.8 15.7 29.6 15.7 27.3C15.7 20.3 21.4 14.7 28.4 14.7C31.8 14.7 35 16 37.4 18.4C39.8 20.8 41.1 24 41.1 27.4C41.1 34.3 35.4 39.6 28.4 39.6ZM35.4 30.5C35 30.3 32.9 29.3 32.5 29.1C32.1 29 31.8 28.9 31.5 29.3C31.2 29.8 30.4 30.7 30.1 31C29.8 31.3 29.5 31.4 29.1 31.2C28.7 31 27.4 30.6 25.9 29.3C24.7 28.2 23.9 26.9 23.6 26.5C23.3 26.1 23.6 25.8 23.8 25.5C24 25.3 24.2 25 24.4 24.8C24.6 24.5 24.7 24.3 24.8 24C24.9 23.7 24.9 23.5 24.8 23.2C24.7 23 23.9 20.9 23.6 20.1C23.3 19.3 23 19.4 22.7 19.4H21.9C21.6 19.4 21.1 19.5 20.7 19.9C20.3 20.3 19.2 21.3 19.2 23.4C19.2 25.5 20.7 27.5 20.9 27.8C21.1 28.1 23.9 32.4 28.2 34.2C29.2 34.6 30 34.9 30.6 35.1C31.6 35.4 32.5 35.3 33.2 35.2C34 35.1 35.7 34.2 36 33.2C36.4 32.2 36.4 31.3 36.3 31.1C36.1 30.9 35.8 30.7 35.4 30.5Z"
          fill="white"
        ></path>
      </svg>
    </a>
  );
};
